import React, {useEffect} from 'react'
import {useAppDispatch, useAppSelector} from '../store/hooks'
import {initAuthListener} from '../services/auth'
import {selectIsInitialized} from '../store/authSlice'
import {GroupType} from '../types/app-types'
import {Route, Routes, useNavigate} from 'react-router-dom'
import AccountPage from './account/AccountPage'
import AccountLayout from './layout/AccountLayout'
import AddPaymentAccountPage from './payment-account/AddPaymentAccountPage'
import AddSupportRequestPage from './support/AddSupportRequestPage'
import BillingPage from './billing/BillingPage'
import MakePaymentPage from './payment/MakePaymentPage'
import MakePaymentResultPage from './payment/MakePaymentResultPage'
import NotFoundPage from './common/NotFoundPage'
import PaymentAccountsPage from './payment-account/PaymentAccountsPage'
import SupportPage from './support/SupportPage'
import PaymentHistoryPage from './payment-history/PaymentHistoryPage'
import Loader from './common/Loader'
import RequiresAuthentication from './auth/RequiresAuthentication'
import LeaseApplicationPage from './lease/LeaseApplicationPage'
import LeaseOverviewPage from './lease/LeaseOverviewPage'
import LeaseTestPage from './lease/LeaseTestPage'
import NewLeaseApplicationPage from './lease/NewLeaseApplicationPage'
import HomePage from './home/HomePage'
import AccessDeniedPage from './common/AccessDeniedPage'
import RequiresGroups from './auth/RequiresGroups'
import SignInPage from './auth/SignInPage'
import SignOutPage from './auth/SignOutPage'

const App = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const isInitialized = useAppSelector(selectIsInitialized)

  useEffect(initAuthListener(dispatch, navigate), [])

  if (isInitialized) {
    return (
      <Routes>
        <Route
          index
          element={
            <RequiresAuthentication>
              <HomePage />
            </RequiresAuthentication>
          }
        />
        <Route
          path="account/:id"
          element={
            <RequiresAuthentication>
              <RequiresGroups groups={[GroupType.Resident]}>
                <AccountLayout />
              </RequiresGroups>
            </RequiresAuthentication>
          }
        >
          <Route index element={<AccountPage />} />
          <Route path="payment-accounts" element={<PaymentAccountsPage />} />
          <Route
            path="add-payment-account"
            element={<AddPaymentAccountPage />}
          />
          <Route path="payment-history" element={<PaymentHistoryPage />} />
          <Route path="make-payment" element={<MakePaymentPage />} />
          <Route
            path="make-payment-result"
            element={<MakePaymentResultPage />}
          />
          <Route path="billing" element={<BillingPage />} />
          <Route path="support" element={<SupportPage />} />
          <Route
            path="add-support-request"
            element={<AddSupportRequestPage />}
          />
        </Route>
        <Route path="lease-test" element={<LeaseTestPage />} />
        <Route path="lease-overview" element={<LeaseOverviewPage />} />
        <Route
          path="new-lease-application"
          element={
            <RequiresAuthentication register={true}>
              <NewLeaseApplicationPage />
            </RequiresAuthentication>
          }
        />
        <Route
          path="lease-application/:id"
          element={
            <RequiresAuthentication register={true}>
              <LeaseApplicationPage />
            </RequiresAuthentication>
          }
        />
        <Route path="sign-in" element={<SignInPage />} />
        <Route path="sign-out" element={<SignOutPage />} />
        <Route path="access-denied" element={<AccessDeniedPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    )
  } else {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    )
  }
}

export default App
